import { createEmptyState } from 'data/createRandomState';
import {
  assignAccount,
  assignAccounts,
  editPeriod,
  movePeriod,
  addAccount,
  importAccounts,
  importAccountsWithAdding,
  sortAccounts,
} from 'utils/stateToState';
import {
  ASSIGN_ACCOUNT,
  ASSIGN_ACCOUNTS,
  UNASSIGN_ACCOUNT,
  EDIT_PERIOD,
  MOVE_PERIOD,
  ADD_ACCOUNT,
  IMPORT_ACCOUNTS,
  IMPORT_ACCOUNTS_WITH_ADDING,
  EDIT_ACCOUNT,
  EDIT_ACCOUNT_DESCRIPTION,
  PERIOD_REORDER,
  SORT_ACCOUNTS,
  SET_ACCOUNTS_FILTER,
} from 'constants/actionTypes';

export default function accounts(state = createEmptyState().accounts, action) {
  switch (action.type) {
    case UNASSIGN_ACCOUNT: {
      const { accountId } = action;
      return assignAccount(state, accountId, null);
    }
    case ASSIGN_ACCOUNT: {
      const { accountId, groupId } = action;
      return assignAccount(state, accountId, groupId);
    }
    case ASSIGN_ACCOUNTS: {
      const { accountIds, groupId } = action;
      return assignAccounts(state, accountIds, groupId);
    }
    case EDIT_PERIOD: {
      const { periodId, periodObj } = action;
      return editPeriod(state, periodId, periodObj);
    }
    case MOVE_PERIOD: {
      const { oldIndex, newIndex } = action;
      return movePeriod(state, oldIndex, newIndex);
    }
    case PERIOD_REORDER: {
      const { periodIds } = action;
      return {
        ...state,
        periodIds,
      };
    }
    case ADD_ACCOUNT: {
      const { accountId } = action;
      return addAccount(state, accountId);
    }
    case IMPORT_ACCOUNTS: {
      const { data, mapping } = action;
      return importAccounts(state, data, mapping);
    }
    case IMPORT_ACCOUNTS_WITH_ADDING: {
      const { data, mapping } = action;
      return importAccountsWithAdding(state, data, mapping);
    }
    case EDIT_ACCOUNT: {
      const accountId = Object.keys(action.account)[0];
      const existingAccount = accountId && state.accountsById[accountId];
      const newAccount = existingAccount
        ? { [accountId]: { ...existingAccount, ...action.account[accountId] } }
        : action.account;

      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          ...newAccount,
        },
      };
    }
    case EDIT_ACCOUNT_DESCRIPTION: {
      const { accountId, newDescription } = action;
      return {
        ...state,
        accountsById: {
          ...state.accountsById,
          [accountId]: {
            ...state.accountsById[accountId],
            description: newDescription,
          },
        },
      };
    }
    case SORT_ACCOUNTS: {
      const { field, rows, sortingOrder } = action;
      return sortAccounts(state, field, rows, sortingOrder);
    }
    case SET_ACCOUNTS_FILTER: {
      const { filter } = action;
      return {
        ...state,
        filter,
      };
    }
    default:
      return state;
  }
}
